import { useActiveProject } from "@/hooks/useActiveProject";

import { isSup } from "@/utils/URoles";

import { ResourceRole } from "@/constants/index";

/**
 * The role that gates the home page's actions: the filtered project's.
 * A view grants nothing - it shows what its owner already reaches - so
 * there is nothing else to fall back on (docs/modele.md, phase 6).
 */
export const useActiveRole = (): string | undefined => {
	const { project } = useActiveProject();
	return project?.role;
};

/**
 * Whether the task actions (edit, duplicate, delete, multi-select) are
 * offered. A filtered project answers with its role; without a filter
 * the list spans every project the view reaches, each with its own
 * role, so the actions are offered and the API's TaskVoter is what
 * refuses a VIEWER's mutation. An archived project is read-only for
 * everyone (the API answers 409 PROJECT.ARCHIVED).
 */
export const useCanWriteTasks = (): boolean => {
	const role = useActiveRole();
	const { project } = useActiveProject();
	return !project || (!project.isArchived && isSup(ResourceRole.USER, role));
};
